import { render, staticRenderFns } from "./PromoStep2.vue?vue&type=template&id=27fac086"
import script from "./PromoStep2.vue?vue&type=script&lang=js"
export * from "./PromoStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports